import {
  Checkbox,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Popover,
  TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import './List-Fliter-Menu.scss';
import { KeyboardArrowRight } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  clearAll: {
    color: 'grey',
    textDecoration: 'underline',
    textAlign: 'right',
    paddingRight: '20px',
    cursor: 'pointer',
  },
}));

const ListFilterMenu = (props) => {
  const {
    menu,
    targetEl,
    handleFilter,
    handleFilterClose,
    hideSearch,
    deviceFilterCount,
    statusFilterCount,
    audienceFilterCount,
    module,
  } = props;
  const [mainAnchorEl, setMainAnchorEl] = useState(null);
  const [subAnchorEl, setSubAnchorEl] = useState(null);
  const [subMenu, setSubMenu] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState({});
  const [searchText, setSearchText] = useState('');
  const classes = useStyles();

  const mainMenuOpen = Boolean(mainAnchorEl);
  const subMenuOpen = Boolean(subAnchorEl);
  const toSafeDomId = (val) => String(val).replace(/[^A-Za-z0-9_.:-]/g, '_');

  useEffect(() => {
    setMainAnchorEl(targetEl);
  }, [targetEl]);

  useEffect(() => {
    if (selectedMenu.subMenu) {
      const filteredSubMenu = searchText
        ? [...selectedMenu.subMenu].filter((item) => {
            return item.name.toLowerCase().includes(searchText.toLowerCase());
          })
        : [...selectedMenu.subMenu];

      const items = filteredSubMenu.map((item) => ({
        ...item,
        selected: item.selected,
      }));
      setSubMenu(items);
    }
  }, [searchText, selectedMenu]);

  const handleMenuClose = () => {
    setMainAnchorEl(null);
    setSubAnchorEl(null);
    handleFilterClose();
    setSelectedMenu({});
  };

  const handleSubenuClose = () => {
    setSubAnchorEl(null);
    setSearchText('');
  };

  const handleMainMenuClick = (event, menuItem, index) => {
    const selectedMenu = { ...menuItem };
    setSelectedMenu(selectedMenu);
    if (selectedMenu.subMenu && selectedMenu.subMenu.length > 0)
      setSubAnchorEl(event.currentTarget);
    if (selectedMenu.subMenu.length === 0) handleFilter(null, selectedMenu.field);
  };

  const handleSelectSubMenuItem = (menuItem, e) => {
    const selectedSubMenu = [...selectedMenu.subMenu];

    const selectedSubMenuIndex = selectedSubMenu.findIndex((o) => o.id === menuItem.id);
    selectedSubMenu[selectedSubMenuIndex] = {
      ...menuItem,
      selected: !menuItem.selected,
    };

    setSelectedMenu({ ...selectedMenu, subMenu: selectedSubMenu });
    handleFilter(selectedSubMenu, selectedMenu.field);
  };

  const getFilterCount = (field) => {
    let count = 0;
    switch (field) {
      case 'deviceTypes':
        count = deviceFilterCount;
        break;
      case 'status':
        count = statusFilterCount;
        break;
      case 'audienceType':
        count = audienceFilterCount;
        break;
      default:
        return '';
    }
    return count > 0 ? <span className='filter-count-badge'>{count}</span> : '';
  };

  const handleClearAllFilters = () => {
    const clearedMenu = menu.map((menuItem) => {
      if (menuItem.subMenu && menuItem.subMenu.length > 0) {
        return {
          ...menuItem,
          subMenu: menuItem.subMenu.map((subItem) => ({
            ...subItem,
            selected: false,
          })),
        };
      }
      return menuItem;
    });

    clearedMenu.forEach((menuItem) => {
      if (menuItem.subMenu && menuItem.subMenu.length > 0) {
        handleFilter(menuItem.subMenu, menuItem.field);
      }
    });

    setSearchText('');
    handleSubenuClose();
    handleMenuClose();
  };

  return (
    <div>
      <Popover
        id='main-menu'
        open={mainMenuOpen}
        anchorEl={mainAnchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: module === 'WELCOME_MESSAGE' ? 'right' : 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: module === 'WELCOME_MESSAGE' ? 'right' : 'center',
        }}
        PaperProps={
          module === 'WELCOME_MESSAGE'
            ? {
                style: {
                  marginTop: '12px',
                  borderRadius: '50%',
                },
              }
            : {}
        }
      >
        <div className='filter-menu'>
          <div className='filter-menu-list'>
            <List component='nav' aria-label='main user menu'>
              {menu &&
                menu.map((menuItem, key) => (
                  <ListItem
                    className={menuItem.field === selectedMenu?.field ? 'selected' : ''}
                    key={key}
                    button
                    onClick={(e) => {
                      handleMainMenuClick(e, menuItem, key);
                    }}
                  >
                    <ListItemText primary={menuItem.title} />
                    {getFilterCount(menuItem.field)}
                    {menuItem.subMenu && menuItem.subMenu.length > 0 && <KeyboardArrowRight />}
                  </ListItem>
                ))}
              {['deviceTypes', 'status', 'audienceType'].every((field) =>
                menu?.some((menuItem) => menuItem?.field === field),
              ) &&
                (deviceFilterCount > 0 || statusFilterCount > 0 || audienceFilterCount > 0) &&
                module === 'WELCOME_MESSAGE'|| 'SENT_MESSAGES' && (
                  <div className={classes.clearAll} onClick={handleClearAllFilters}>
                    Clear
                  </div>
                )}
            </List>
          </div>
        </div>
      </Popover>
      {subMenu && (
        <Popover
          id='second-menu'
          open={subMenuOpen}
          anchorEl={subAnchorEl}
          onClose={handleSubenuClose}
          className='filter-menu-secondary'
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <div className='filter-menu filter-menu-secondary'>
            <div className='filter-menu-list'>
              <List component='nav' aria-label='main user menu'>
                <ListItem className='mb-3'>
                  {!hideSearch && !selectedMenu.hideSearch && (
                    <TextField
                      className='col-md-12'
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      label={'Search ' + selectedMenu.title}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </ListItem>
                {subMenu?.map((item, key) => {
                  const rawId = item?.id ?? item?.name ?? key;
                  const checkboxId = `filter-${selectedMenu?.field}-${toSafeDomId(rawId)}`;
                  return (
                    <ListItem
                      key={key}
                      button
                      onClick={() => handleSelectSubMenuItem(item)}
                      className='filter-subitem'
                    >
                      <Checkbox
                        id={checkboxId}
                        checked={!!item?.selected}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleSelectSubMenuItem(item);
                        }}
                        inputProps={{ 'aria-labelledby': `${checkboxId}-label` }}
                        tabIndex={-1}
                      />
                      <label
                        id={`${checkboxId}-label`}
                        htmlFor={checkboxId}
                        className='filter-subitem-label'
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            e.stopPropagation();
                            handleSelectSubMenuItem(item);
                          }
                        }}
                        role='button'
                        tabIndex={0}
                        style={{ cursor: 'pointer' }}
                      >
                        {item.name}
                      </label>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default ListFilterMenu;
